module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "Poem-title",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Look Up")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-first"
  }, [_vm._v("We were friends ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We were colleagues")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We shared summers and winters")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("We protected each other’s backs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Took care of all our needs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("I then made a sacrifice you did not")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Not through choice")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Just good or bad luck")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("So tell me my old friend")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Why do you look to the floor?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("When we pass each other")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Your eyes touch the floor")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("You tell me not to come around")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Am I dirty or unclean now?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Why do you frown?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Is it guilt or fear or both?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("And when I came back")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You still looked to my feet")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Friends no more?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("It’s not my face you can’t stand")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I suspect it’s yours you no longer adore")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-148a4afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398433502_EPUB8.vue
// module id = 81
// module chunks = 0